import { Model } from 'components/discovery/utils/model.js'

export type Prediction = {
  description: string,
  place_id: string,
  reference: string,
  terms: Array<{
    offset: number,
    value: string,
  }>
}

export type Autocomplete = {
  predictions: Array<Prediction>,
  status: string,
}

export class AutocompleteModel extends Model<Autocomplete> implements Autocomplete {
  predictions: Array<Prediction> = []
  status = 'OK'
}
